import React from 'react'
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap'
import { handlePdfImages } from '../utils/common';

type AppProps={
    modal:boolean;
    toggleModal:()=>void;
    pdfTemplateModalSelected:string
}

const GeneralSettingPdfPreviewModal = ({modal,toggleModal,pdfTemplateModalSelected}: AppProps) => {
  return (
    <Modal isOpen={modal} toggle={toggleModal} size={"xl"}>
       <ModalHeader toggle={toggleModal}>
        Pdf Preview
      </ModalHeader>
      <ModalBody style={{width:"100%",height:"100%" }}>
       <img src={handlePdfImages(pdfTemplateModalSelected)} width={"100%"} style={{objectFit:"cover"}} alt="" />
      </ModalBody>
      <ModalFooter>
        <div className="text-right d-flex">
          <span className="pointer form-control" onClick={toggleModal}>
            Cancel
          </span>
        </div>
      </ModalFooter>
    </Modal>
  )
}

export default GeneralSettingPdfPreviewModal
